export const isWeb = () => {
  // In react-native 'document' doesn't exist
  // When we runs tests, document exist do we check document["env"]
  // defined in each setupTests on each sub-project
  if (typeof document !== 'undefined' && document['env'] !== 'react-native') {
    // This is the web!
    return true;
  } else {
    // This is react-native
    return false;
  }
};
